import classNames from 'classnames'
import React, { type FC } from 'react'
import { observer } from 'mobx-react-lite'
import { Switch } from 'shared/ui'
import { TitledRow } from 'shared/ui/TitledRow/TitledRow'
import { type IntegrationHubspotSettingsTimelineStore } from 'pages/settings/pages/integrations/pages/integrationSettings/IntegrationHubspotSettings/store/IntegrationHubspotSettingsTimelineStore'
import styles from './styles.module.scss'

type IIntegrationHubspotSettingsTimelineProps = { store: IntegrationHubspotSettingsTimelineStore }

export const IntegrationHubspotSettingsTimeline: FC<IIntegrationHubspotSettingsTimelineProps> =
  observer(({ store }) => {
    const {
      dailyBundles,
      timelineAssociations,
      onTimelineAssociationsToggle,
      onLogeChange,
      getLog,
    } = store

    return (
      <div className={classNames(styles.root, { [styles.expanded]: dailyBundles })}>
        {dailyBundles && (
          <div className={styles.settings}>
            <TitledRow title={'Log calls'}>
              <Switch
                size='middle'
                value={getLog('log_calls')}
                onChange={onLogeChange('log_calls')}
              />
            </TitledRow>
            <TitledRow title={'Log messages'}>
              <Switch
                size='middle'
                value={getLog('log_messages')}
                onChange={onLogeChange('log_messages')}
              />
            </TitledRow>
            <TitledRow title={'Log notes'}>
              <Switch
                size='middle'
                value={getLog('log_notes')}
                onChange={onLogeChange('log_notes')}
              />
            </TitledRow>
            <TitledRow title={'Log voicemail'}>
              <Switch
                size='middle'
                value={getLog('log_voicemails')}
                onChange={onLogeChange('log_voicemails')}
              />
            </TitledRow>
          </div>
        )}

        <TitledRow
          title={'Log activities to all associated objects'}
          label={'New activity will be created in associated objects'}
          verticalAlign={'start'}
        >
          <Switch
            size='middle'
            value={dailyBundles ? timelineAssociations : false}
            onChange={onTimelineAssociationsToggle}
            disabled={!dailyBundles}
            tooltipProps={{
              label: !dailyBundles ? (
                <>
                  Enable &apos;Log activities in HubSpot&apos;
                  <br />
                  to log to associated objects.
                </>
              ) : undefined,
              placement: 'top',
            }}
          />
        </TitledRow>
      </div>
    )
  })
